<template>
  <div>
    <div
      v-if="value"
      class="table_label"
      :class="[primary ? 'primary' : '', info ? 'info' : '']"
    >
      <span>{{ text }}</span>
      <span>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    info: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    labelKey: { type: String, default: '' },
    funcID: { type: String, default: '' },
    global: { type: Boolean, default: false },
  },
  computed: {
    text() {
      if (!this.labelKey) return this.label || ''
      const funcID = this.global ? 'INDEX' : ''
      const labelKey = [funcID, this.labelKey].filter(Boolean).join('.')
      return this.$l(labelKey) || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.table_label {
  span:empty {
    display: none;
  }
  span:first-child {
    &::after {
      content: '：';
    }
  }
}
.table_label.info {
  span:last-child {
    color: #303133;
  }
}
.table_label.primary {
  span:last-child {
    color: #409eff;
  }
}
</style>
